import { toRem, baseVariables } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledCardCarouselContainer = styled.div`
  @media ${baseVariables.mediaQuery.xl} {
    display: 'block'
  }
  .aem-container:first-child {
    margin-left: 0;
  }
  .carousal_header {
    display: flex;
    flex-direction: 'row'
    justify-content: 'space-between'
    align-items: 'unset'
    width: auto;
    @media ${baseVariables.mediaQuery.md} {
      width: 'auto'
    }

    .carousal_header--cta {
      display: flex;
      align-items: 'flex-end'
      text-wrap: nowrap;
    }
  }
  .glide {
    &__track {
      padding-top: 0;

      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }

    .center__align__track {
      @media ${baseVariables.mediaQuery.md} {
        display: flex;
        justify-content: center;
      }

      .glide__slides {
        @media ${baseVariables.mediaQuery.md} {
          justify-content: center;
          width: unset !important;
          li,
          div {
            width: auto !important;
          }
        }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
      .carouselControlType1 {
        .right-arrow {
          right: -1rem;
          @media ${baseVariables.mediaQuery.sm} {
            right: -1.25rem;
          }
        }
        .left-arrow {
          left: -1rem;
          @media ${baseVariables.mediaQuery.sm} {
            left: -1.25rem;
          }
        }
      }
    }
  }
  .glide--swipeable {
    cursor: default;
  }

  [data-component-name='m-ui-library-CardVertical'] > div {
    border-radius: 0;
    box-shadow: unset;
    .card-vertical_chevron {
      &[class*='icon-arrow-']:before {
        font-size: ${toRem(24)};
      }
    }
  }

  .icon-arrow-left-external:hover::before,
  .icon-arrow-left-external.focus-visible::before {
    transform: rotate(45deg);
    transition: 0.15s all ease-in;
  }

  .center__align__track {
    [data-component-name='m-ui-library-CardLayered'] {
      div[data-variation='square'] {
        @media ${baseVariables.mediaQuery.md} {
          max-width: ${toRem(348)};
        }
        @media ${baseVariables.mediaQuery.lg} {
          max-width: ${toRem(364)};
        }
      }
    }
  }
  [data-variation='standard'] .card-vertical__body {
    padding: ${toRem(24)} ${toRem(24)} ${toRem(8)} ${toRem(24)};
  }

  .card-layered,
  .card-vertical {
    border-radius: 0 !important;
  }

  .card-vertical {
    .card-vertical_heading {
      margin: 0 0 ${toRem(16)};
    }
    .card-vertical__body {
      align-items: flex-start !important;
      * {
        text-align: left !important;
      }
      .card-vertical_eyebrow {
        margin-bottom: ${toRem(16)} !important;
      }
      .card-vertical_detail {
        margin: 0 0 ${toRem(16)};
        .card-vertical-description {
          margin: 0;
          font-size: ${toRem(14)};
          font-weight: 500;
          line-height: ${toRem(21)};
          display: -webkit-box;
          max-width: 100%;
          .description-height {
            margin-bottom: ${toRem(16)};
          }
        }
      }
      .card-vertical_description {
        .description-height {
          margin-bottom: ${toRem(16)};
          font-size: ${toRem(14)};
          font-weight: 500;
          line-height: ${toRem(21)};
        }
      }
      .m-link-tertiary-button,
      .m-link-tertiary-button-external {
        color: #003153;
      }
      .text-container {
        margin: 0;
      }
      a {
        border-radius: unset;
      }
    }
  }

  .m-badge-overlay-merch {
    color: ${baseVariables.color['base20']};
    background-color: ${baseVariables.color['base10']} !important;
    padding: ${toRem(8)};
  }
`;
